import { Button, IconButton } from "../../../controls/TooltipControls";
import { truthy } from "../../../util/util";
import { setModAttributes } from "../actions/mods";
import * as React from "react";
import { FormControl } from "react-bootstrap";
import { useDispatch } from "react-redux";
function Input(props) {
    const onChange = React.useCallback((evt) => {
        props.onChange(evt.currentTarget.value);
    }, [props.onChange]);
    return (React.createElement(FormControl, { type: "text", value: props.value ?? "", onChange: onChange }));
}
function Author(props) {
    const { t, gameId, mod } = props;
    const [edit, setEdit] = React.useState(false);
    const [authorTemp, setAuthor] = React.useState(mod.attributes?.author);
    const [uploaderTemp, setUploader] = React.useState(mod.attributes?.uploader);
    const [urlTemp, setURL] = React.useState(mod.attributes?.uploaderUrl);
    const dispatch = useDispatch();
    const changeEdit = React.useCallback((doEdit = true) => {
        setAuthor(mod.attributes?.author);
        setUploader(mod.attributes?.uploader);
        setURL(mod.attributes?.uploaderUrl);
        setEdit(doEdit);
    }, [setEdit, mod, setAuthor, setUploader, setURL]);
    const startEdit = React.useCallback(() => {
        changeEdit(true);
    }, [changeEdit]);
    const cancel = React.useCallback(() => {
        changeEdit(false);
    }, [changeEdit]);
    const save = React.useCallback(() => {
        dispatch(setModAttributes(gameId, mod.id, {
            author: authorTemp,
            uploader: uploaderTemp,
            uploaderUrl: urlTemp,
        }));
        changeEdit(false);
    }, [mod, dispatch, authorTemp, uploaderTemp, urlTemp, changeEdit]);
    if (edit) {
        return (React.createElement("div", null,
            React.createElement("table", null,
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Author")),
                        React.createElement("td", null,
                            React.createElement(Input, { value: authorTemp, onChange: setAuthor }))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Uploader")),
                        React.createElement("td", null,
                            React.createElement(Input, { value: uploaderTemp, onChange: setUploader }))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Uploader URL")),
                        React.createElement("td", null,
                            React.createElement(Input, { value: urlTemp, onChange: setURL }))))),
            React.createElement(Button, { onClick: cancel, tooltip: t("Cancel") }, t("Cancel")),
            " ",
            React.createElement(Button, { onClick: save, tooltip: t("Save") }, t("Save"))));
    }
    else {
        const authors = [];
        if (truthy(mod.attributes?.author)) {
            authors.push(mod.attributes.author);
        }
        if (truthy(mod.attributes?.uploader) &&
            mod.attributes?.uploader !== mod.attributes?.author) {
            authors.push(mod.attributes.uploader);
        }
        const authorP = mod.attributes?.uploaderUrl !== undefined ? (React.createElement("a", { href: mod.attributes?.uploaderUrl }, authors.join(" & "))) : (React.createElement("p", null, authors.join(" & ")));
        return (React.createElement("div", { style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                maxWidth: "20em",
            } },
            authorP,
            " ",
            mod.state === "installed" ? (React.createElement(IconButton, { icon: "edit", tooltip: t("Edit"), onClick: startEdit, className: "btn-embed" })) : null));
    }
}
export default Author;
